import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useApiKey } from '../context/ApiKeyContext';

const StyledFooter = styled.footer`
  margin-top: 4rem;
  display: flex;
  gap: 1.5rem;
  font-size: 0.85rem;

  a, button {
    color: #999;
    text-decoration: none;

    &:hover {
      color: #0d9488;
      text-decoration: underline;
    }
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
`;

const Footer = () => {
  const { isKeyValid, clearApiKey } = useApiKey();

  return (
    <StyledFooter>
      <Link to="/privacy">Privacy Notice</Link>
      <Link to="/terms">Terms & Disclaimer</Link>
      {isKeyValid && (
        <LinkButton onClick={clearApiKey}>Remove API Key</LinkButton>
      )}
    </StyledFooter>
  );
};

export default Footer;
